module.exports = __webpack_public_path__ + "static/img/bip10B2.48a5510.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bip10B2.png
// module id = B29m
// module chunks = 73